import axios from "axios";
import { API_URL } from "./apiRoutes";
import { commonService } from "./commonService";
import { json } from "d3";

// DATA SEND LIKE BELOW OBJECT
// {
//   method: "",
//   url: "",
//   body: {
//     username: "",
//     password: "",
//   }
// }

// IF formType PARAMETER IS TRUE THEN IT WILL BE FORM DATA OTHERWISE NORMAL JSON

export const apiCall = async (data, formType) => {
    try {
        if (data) {
            if (data?.body) {
                data.body.modulenames = commonService.getCurrentModuleName()
            }
        }
        let formData = new FormData();

        if (formType) {
            for (const [key, value] of Object.entries(data?.body)) {
                if (
                    typeof value === "object" &&
                    Array.isArray(value) &&
                    key !== "componentjson" &&
                    key !== "usersid"
                ) {
                    value?.map((item, index) => {
                        for (const [nestedKey, nestedValue] of Object.entries(item)) {
                            formData.append(`${key}[${index}].${nestedKey}`, nestedValue);
                        }
                    });
                } else if (
                    typeof value === "object" &&
                    Array.isArray(value) &&
                    key === "usersid"
                ) {
                    value?.map((item, index) => {
                        formData.append(`${key}[${index}]`, item);
                    });
                } else {
                    formData.append(`${key}`, value);
                }
            }
        }
        let headers = formType
            ? commonService.getHeadersFromData()
            : commonService.getHeaders();
        if (data?.url.indexOf(API_URL.BASE_API_URL.SnapShot) >= 0) {
            headers = formType
                ? commonService.getNodeHeadersFromData()
                : commonService.getNodeHeaders();
        }
        if (data?.url === API_URL.PROPERTY_CHAT.RMCHATAPI) {
            headers = commonService.getRMAPIHeaders();
        }

        if (data?.url === API_URL.BASE_API_URL.UserManagement + API_URL.SSOUSEREMAILVERIFICATION) {
            if (headers) {
                const dd = new Date();
                const hour = String(dd.getUTCHours()).padStart(2, '0');
                const day = String(dd.getUTCDate()).padStart(2, '0');
                const month = String(dd.getUTCMonth() + 1).padStart(2, '0');
                const year = String(dd.getUTCFullYear());
                const token = "[hour][day][month][year]EQszrXKvVHfkYP2l3Ar7rd11b6p5CufEPCHRqlaD8eawyXSKXNgsDg==[year][month][day][hour]"
                    .replaceAll("[hour]", hour)
                    .replaceAll("[day]", day)
                    .replaceAll("[month]", month)
                    .replaceAll("[year]", year);

                headers.key = token;
            }
        }

        let response = await axios({
            method: data.method,
            url: data?.url,
            data: formType ? formData : data?.body,
            headers: headers,
        });

        if (data.url.indexOf(API_URL.BASE_API_URL.SnapShot) >= 0) {
            let snapshotContainers = document.getElementsByClassName(
                "snapshot_data_object"
            );
            let dataArray = [];
            if (snapshotContainers && snapshotContainers.length > 0) {
                let hidden =
                    snapshotContainers[0].getElementsByClassName("hdnSnapshotId");
                if (hidden && hidden.length > 0) {
                    if (hidden[0]?.value) {
                        dataArray = JSON.parse(hidden[0]?.value);
                        hidden[0]?.remove();
                    }
                }
                dataArray.push({ data: response?.data, description: "" });
                const hiddenSpan = document.createElement("input");
                hiddenSpan.type = "hidden";
                hiddenSpan.value = JSON.stringify(dataArray);
                hiddenSpan.className = "hdnSnapshotId";
                snapshotContainers[0].appendChild(hiddenSpan);
            }
        }

        return response?.data;
    } catch (error) {
        return error;
    }
};
